<template>
  <div class="flex flex-col gap-2">
    <div class="flex flex-row gap-2">
      <div
        class="flex-1 bg-untitled-gray-100 rounded-md h-32 relative flex-col flex justify-center items-center gap-2 animate-pulse"
      >

      </div>
      <div
        class="flex-1 bg-untitled-gray-100 rounded-md h-32 relative flex-col flex justify-center items-center gap-2 animate-pulse"
      >

      </div>
    </div>
    <div class="flex flex-row gap-2">

      <div
        class="flex-1 bg-untitled-gray-100 rounded-md h-32 relative flex-col flex justify-center items-center gap-2 animate-pulse"
      >

      </div>

      <div
        class="flex-1 bg-untitled-gray-100 rounded-md h-32 relative flex-col flex justify-center items-center gap-2 animate-pulse"
      >

      </div>
    </div>
  </div>
</template>

<script setup>
// import LoadingText from "@/components/utilities/loading/LoadingText.vue";
</script>

<style lang="scss" scoped></style>
